module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_002.png
// module id = 947
// module chunks = 0